export const ALMOST_BLACK = '1f1f24'
export const LIGHT_GRAY = 'f2f2f2'
export const RED = 'de0b00'
export const SCARCITY_LOGO_RED = 'ff261c'
export const WHITE = 'ffffff'
export const TRANSPARENT = 'transparent'
